import type { Plugin } from 'vue'

const CHUNK_RELOAD_KEY = 'chunk-reload-at'
const CHUNK_RELOAD_COOLDOWN_MS = 10_000

function canReload (): boolean {
  try {
    const lastReloadAt = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY))

    if (lastReloadAt && Date.now() - lastReloadAt < CHUNK_RELOAD_COOLDOWN_MS) {
      return false
    }

    sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()))
    return true
  } catch {
    return false
  }
}

export const ChunkReloadPlugin: Plugin = {
  install: () => {
    window.addEventListener('vite:preloadError', (event) => {
      if (canReload()) {
        event.preventDefault()
        window.location.reload()
      }
    })
  }
}
